//
//
//
//

import goldBoxEcuAttributesQuery from '~/apollo/queries/product/gold-box-ecu-attributes'

export default {
  props: {
    productId: String
  },
  apollo: {
    goldBoxEcuAttributes: {
      prefetch: true,
      query: goldBoxEcuAttributesQuery,
      variables () {
        return { id: this.productId }
      }
    }
  }
}
